module.exports = __webpack_public_path__ + "static/about1-ffa91c640df00cca1325b515068b44ae.jpg";